import { render } from "./LoadingIndicator.vue?vue&type=template&id=274af8aa&scoped=true"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js"

import "./LoadingIndicator.vue?vue&type=style&index=0&id=274af8aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274af8aa"]])

export default __exports__